import { render, staticRenderFns } from "./AccountCancellation.vue?vue&type=template&id=46fdfcae&scoped=true"
import script from "./AccountCancellation.vue?vue&type=script&lang=js"
export * from "./AccountCancellation.vue?vue&type=script&lang=js"
import style0 from "./AccountCancellation.vue?vue&type=style&index=0&id=46fdfcae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fdfcae",
  null
  
)

export default component.exports